/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ModifyCriterionDraft } from './modifyCriterionDraft';

export interface ModifyCriteriaRequest {
  /**
     * @minLength 1
     * @maxLength 1000
     */
  user_request: string;
  criteria?: ModifyCriterionDraft[] | null;
}
